export default "__VITE_ASSET__CML943BN__"